jQuery(document).ready(function($) { 

	var LARGEUR_MAX_MOBILE = 799;

	var header = $('#masthead');
	var h_window = $(window).height();

	 /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */
   $(window).scroll(function () {
     // if(l_window > 1023){
        action_on_scroll();
     // }
    });



    function action_on_scroll(){
      l_window = parseInt($(window).width());
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }


if($('body').hasClass('home')){
		 // Cache selectors
	var lastId,
	    topMenu = $("#MenuTop-js"),
	    Sitenavigation = $("#site-navigation"),
	    Menutoggle = $('.menu-toggle');
	    topMenuHeight = 110,
	    // All list items
	    menuItems = topMenu.find("a"),
	    // Anchors corresponding to menu items
	    scrollItems = menuItems.map(function(){
	    	var only_anchor = $(this).attr("href").split('#');
	    	console.log(only_anchor[1]);
        var item = $("#"+only_anchor[1]); //var item = $($(this).attr("href").split('#'));
        if (item.length) { return item; }
      });

	   var l_window = parseInt($(window).width());
	  if(l_window < 769){

	  		topMenuHeight = 0;

	  }
	// Bind click handler to menu items
	// so we can get a fancy scroll animation
	menuItems.click(function(e){
	  var item_split = $(this).attr("href").split('#');
	  var href = "#"+item_split[1];
	  var variable = 0;
	  	  if (href == "#ZOA")  variable = 140;
	      var offsetTop = href[1] === "#" ? 0 : $(href).offset().top-topMenuHeight+1-variable;
	      if(Sitenavigation.hasClass('toggled')){
	      	Menutoggle.trigger( "click" );
		      $('html, body').stop().animate({ 
			      scrollTop: offsetTop
			  }, 500);

	      }else{
		      	 $('html, body').stop().animate({ 
			      scrollTop: offsetTop
			  }, 500);
	      }
		 
		  e.preventDefault();
	});

	var other_link =  $('.like-js-home, .intro-link-js');
	other_link.click(function(e){
		var item_split = $(this).attr("href").split('#');
		var href = "#"+item_split[1];
	      offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;
		  $('html, body').stop().animate({ 
		      scrollTop: offsetTop
		  }, 300);
		  e.preventDefault();
	});

	// Bind to scroll
	$(window).scroll(function(){
	   // Get container scroll position
	   var fromTop = $(this).scrollTop()+topMenuHeight;
	   
	   // Get id of current scroll item
	   var cur = scrollItems.map(function(){
	   	if($(this).attr('id') == "realisations") variable_top = 170;else variable_top = 0;
	     if ($(this).offset().top - variable_top < fromTop)
	       return this;
	   });
	   // Get the id of the current element
	   cur = cur[cur.length-1];
	   var id = cur && cur.length ? cur[0].id : "";
	   
	 //  console.log("A"+object_var.site_url+"/#"+id);

	   if (lastId !== id) {
	       lastId = id;
	       // Set/remove active class

	       menuItems
	         .parent().removeClass("active_menu")
	         .end().filter("[href='"+object_var.site_url+"#"+id+"']").parent().addClass("active_menu");
	   }                   
	});
}




  
// /**************************************************************************************/
// /*********************** MODULE TOP HOME / DIAPO TXT IMAGE  *********************************/
// /**************************************************************************************/

   var swiper_container_Tophome = new Swiper('.swiper-container-TopHome', {

  // If we need pagination
    spaceBetween: 60, // try '5%' if you want
    slidesPerView: 1,
    loop: true,
    centeredSlides:false,
     autoplay: {
        delay: 5000,
        disableOnInteraction: true,
    },

   pagination: {
         el: '.swiper-bullet-pagination',
         clickable: true
    },

    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },

});


// var menu_pagination_mA = [];
// var titleMASlide = document.querySelectorAll('.swiper-container-Expertises .ListExpertisesItem-TitleMobile');
// titleMASlide.forEach(function (sandwich, index) {
//   menu_pagination_mA.push(sandwich.innerHTML);
// });

// var swiper_expertises = new Swiper('.swiper-container-Expertises', {

//   // If we need pagination
//     spaceBetween: 16, // try '5%' if you want
//     centeredSlides: true,
//     slidesPerView: 1.25,
//     loop: true,

 

//    pagination: {
//          el: '.swiper-bullet-pagination',
//          clickable: true
//     },

//     breakpoints: {
//       769: { // a partir de 769

//         spaceBetween: 20,
//         centeredSlides: false,
//         slidesPerView: 1,
//         loop: false,

//         pagination: {
//         el: '.ListExpertises-swipertxt',
//         clickable: true,
//           renderBullet: function (index, className) {
//             return '<span class="button-label ' + className + '">' + (menu_pagination_mA[index]) + ' <i class="icon-next-arrow" aria-hidden="true"></i></span>';
//           },
//         },
//       }
//     },
//     on: {
//     breakpoint: function (swiper) {
//       this.update();
//     }
//   },

//   autoplay: {
//     delay: 3000,
//     disableOnInteraction: true
//   }
// });
/**************************************************************************************/
/*********************** FIN MODULE A / Services *********************************/
/**************************************************************************************/
	
		// $('.to_nicedropdown-js').niceSelect();
	  // $('.to_nicedropdown-js').on('change', function() {
    // 	document.location=this.value;
  	// });

	  //  ScrollTrigger.create({
	  //     trigger: ".center_header",
	  //     start: "top 100%",
	  //     end: "bottom 0px",
	  //     onEnter: () => $('.center_header').addClass('revealed'),
	  //     onLeave: () => $('.center_header').removeClass('revealed'),
	  //     onEnterBack: () => $('.center_header').addClass('revealed'),
	  //     onLeaveBack: () => $('.center_header').removeClass('revealed'),
    // });

	  //    ScrollTrigger.create({
	  //     trigger: ".s3",
	  //     start: "top 100%",
	  //     end: "bottom 0px",
	  //     onEnter: () => $('.s3').addClass('revealed'),
	  //     onLeave: () => $('.s3').removeClass('revealed'),
	  //     onEnterBack: () => $('.s3').addClass('revealed'),
	  //     onLeaveBack: () => $('.s3').removeClass('revealed'),
    // });

	  //  ScrollTrigger.create({
	  //     trigger: ".s5",
	  //     start: "top 100%",
	  //     end: "bottom 0px",
	  //     onEnter: () => $('.s5').addClass('revealed'),
	  //     onLeave: () => $('.s5').removeClass('revealed'),
	  //     onEnterBack: () => $('.s5').addClass('revealed'),
	  //     onLeaveBack: () => $('.s5').removeClass('revealed'),
    // });

	  //   ScrollTrigger.create({
	  //     trigger: ".s7.Contact",
	  //     start: "top 100%",
	  //     end: "bottom 0px",
	  //     onEnter: () => $('.s7').addClass('revealed'),
	  //     onLeave: () => $('.s7').removeClass('revealed'),
	  //     onEnterBack: () => $('.s7').addClass('revealed'),
	  //     onLeaveBack: () => $('.s7').removeClass('revealed'),
    // });


	   if ($('.RowImgTxtOn').length > 0) {
 
	   gsap.utils.toArray(".RowImgTxtOn").forEach(RowImgTxtOn => {
	   var txt = RowImgTxtOn.querySelector(".RowImgTxtOn-Txt");
		 gsap.from(txt,1,{
          top:'-50px',
          ease: "power0.out",
          scrollTrigger: {
            trigger:RowImgTxtOn,
             //start: "top bottom", // the default values
             end: "start end",
             scrub: true,
             //invalidateOnRefresh: true,
            //immediateRender:false,
            toggleActions: "restart pause resume restart",
          }, 
        });

		});


		 gsap.utils.toArray(".RowTxtImg-Item").forEach(RowTxtImg_Item => {
	   var img = RowTxtImg_Item.querySelector(".RowTxtImg-Img");
		 gsap.from(img,1,{
          top:'-50px',
          ease: "power0.out",
          scrollTrigger: {
            trigger:RowTxtImg_Item,
             //start: "top bottom", // the default values
             end: "start end",
             scrub: true,
             //invalidateOnRefresh: true,
            //immediateRender:false,
            toggleActions: "restart pause resume restart",
          }, 
        });

  
	});

	}



  

  // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });




}); // fin ready menu